//A4美术馆管理
export default [
  {
    path: '/guidesManage',
    component: () => import('@/pages/brandsManage/A4/A4GuidesManage/guidesManage.vue'),
    name: 'guidesManage',
    title: '一级导览菜单',
    meta: {
      title: '一级导览菜单',
    },
  },
  {
    path: '/secondeGuidesManage',
    component: () =>
      import('@/pages/brandsManage/A4/A4GuidesManage/secondeGuidesManage.vue'),
    name: 'secondeGuidesManage',
    title: '二级导览菜单',
    meta: {
      title: '二级导览菜单',
    },
  },
  {
    path: '/memberCardManage',
    component: () => import('@/pages/brandsManage/A4/A4MemberManage/memberCardManage.vue'),
    name: 'memberCardManage',
    title: '会员卡管理',
    meta: {
      title: '会员卡管理',
    },
  },
  {
    path: '/menberCheckManage',
    component: () => import('@/pages/brandsManage/A4/A4MemberManage/menberCheckManage.vue'),
    name: 'menberCheckManage',
    title: '会员/审核',
    meta: {
      title: '会员/审核',
    },
  },
  {
    path: '/memberRenew',
    component: () => import('@/pages/brandsManage/A4/A4MemberManage/memberRenew.vue'),
    name: 'memberRenew',
    title: '续卡记录',
    meta: {
      title: '续卡记录',
    },
  },
  {
    path: '/joinUsManage',
    component: () => import('@/pages/brandsManage/A4/JoinUs/joinUsManage.vue'),
    name: 'joinUsManage',
    title: '加入我们列表管理',
    meta: {
      title: '加入我们列表管理',
    },
  },
  {
    path: '/menverCodeRecord',
    component: () => import('@/pages/brandsManage/A4/A4MemberManage/menverCodeRecord.vue'),
    name: 'menverCodeRecord',
    title: '会员码记录',
    meta: {
      title: '会员码记录',
    },
  },
  {
    path: '/manualGuideManege',
    component: () => import('@/pages/brandsManage/A4/A4GuidesManage/manualGuideManege.vue'),
    name: 'menverCodeRecord',
    title: '人工导览管理',
    meta: {
      title: '人工导览管理',
    },
  },
  {
    path: '/resumeManage',
    component: () => import('@/pages/brandsManage/A4/JoinUs/resumeManage.vue'),
    name: 'resumeManage',
    title: '志愿者管理',
    meta: {
      title: '志愿者管理',
    },
  },
  {
    path: '/resumeDetail',
    component: () => import('@/pages/brandsManage/A4/JoinUs/resumeDetail.vue'),
    name: 'resumeDetail',
    title: '查看简历详情',
    meta: {
      title: '查看简历详情',
    },
  },
  {
    path: '/serveAppointment',
    component: () => import('@/pages/brandsManage/A4/JoinUs/serveAppointment.vue'),
    name: 'serveAppointment',
    title: '服务预约记录',
    meta: {
      title: '服务预约记录',
    },
  },
  {
    path: '/signInStatistics',
    component: () => import('@/pages/brandsManage/A4/JoinUs/signInStatistics.vue'),
    name: 'signInStatistics',
    title: '签到统计',
    meta: {
      title: '签到统计',
    },
  },
  {
    path: '/serveGroup',
    component: () => import('@/pages/brandsManage/A4/JoinUs/serveGroup.vue'),
    name: 'serveGroup',
    title: '服务分组',
    meta: {
      title: '服务分组',
    },
  },
  {
    path: '/volunteerWall',
    component: () => import('@/pages/brandsManage/A4/JoinUs/volunteerWall.vue'),
    name: 'volunteerWall',
    title: '志愿者墙管理',
    meta: {
      title: '志愿者墙管理',
    },
  },
  {
    path: '/volunteerRecruitment',
    component: () => import('@/pages/brandsManage/A4/JoinUs/volunteerRecruitment.vue'),
    name: 'volunteerRecruitment',
    title: '志愿者招募管理',
    meta: {
      title: '志愿者招募管理',
    },
  },
  {
    path: '/A4TicketOrder',
    component: () => import('@/pages/brandsManage/A4/A4Ticket/A4TicketOrder.vue'),
    name: 'A4TicketOrder',
    title: '票务订单管理',
    meta: {
      title: '票务订单管理',
    },
  },
  {
    path: '/A4TicketManage',
    component: () => import('@/pages/brandsManage/A4/A4Ticket/A4TicketManage.vue'),
    name: 'A4TicketManage',
    title: '票务管理',
    meta: {
      title: '票务管理',
    },
  },
  {
    path: '/A4TicketProjectManage',
    component: () => import('@/pages/brandsManage/A4/A4Ticket/A4TicketProjectManage.vue'),
    name: 'A4TicketProjectManage',
    title: '票务项目管理',
    meta: {
      title: '票务项目管理',
    },
  },
  {
    path: '/A4TicketPointManage',
    component: () => import('@/pages/brandsManage/A4/A4Ticket/A4TicketPointManage.vue'),
    name: 'A4TicketPointManage',
    title: 'A4领票点管理',
    meta: {
      title: 'A4领票点管理',
    },
  },
]
